import React from 'react';

import Amplify from '@aws-amplify/core';
import aws_exports from './aws-exports';
import { Auth } from 'aws-amplify';

import SubContainer from './subs/SubContainer';
import Sub from './subs/Sub';
import DashboardContainer from './dashboards/DashboardContainer';
import DashboardDrawer from './dashboards/drawer/DashboardDrawer';
import Dashboard from './dashboards/display/Dashboard';
import ChartContainer from './charts/ChartContainer';
import Greeting from './user/Greeting';
import 'typeface-roboto';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import Copyright from './Copyright';
import PropTypes from 'prop-types';

Amplify.configure(aws_exports);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    menuButton: {
      marginRight: theme.spacing(2),
    },
    paddingBottom: '50px',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: '#fff',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  appFooter: {
    zIndex: theme.zIndex.drawer + 1,
    top: 'auto',
    bottom: 0,
    backgroundColor: '#fff',
  },
  logo: {
    maxWidth: 160,
  },
}));

async function signOut() {
  try {
    await Auth.signOut();
    //TODO: quick fix here
    window.location.reload();
  } catch (error) {
    console.log(error);
  }
}

const App = (props) => {
  const classes = useStyles();

  if (props.authState !== 'signedIn') {
    return null;
  }

  return (
    <div className={classes.root}>
      <SubContainer>
        <CssBaseline />
        <AppBar color="primary" position="fixed" className={classes.appBar}>
          <Toolbar>
            <Sub />
            <Typography className={classes.content}></Typography>
            <Greeting />
            <Button variant="contained" color="primary" onClick={signOut}>
              Sign out
            </Button>
          </Toolbar>
        </AppBar>
        <DashboardContainer>
          <ChartContainer>
            <DashboardDrawer />
            <main className={classes.content}>
              <Toolbar />
              <Dashboard />
            </main>
          </ChartContainer>
        </DashboardContainer>
        <AppBar position="fixed" color="primary" className={classes.appFooter}>
          <Toolbar>
            <Copyright />
            <Typography className={classes.content}></Typography>

            <img
              src={process.env.PUBLIC_URL + '/DC-Logo-Left-224.png'}
              alt="logo"
              className={classes.logo}
            ></img>
          </Toolbar>
        </AppBar>
      </SubContainer>
    </div>
  );
};

App.propTypes = {
  authState: PropTypes.any,
};

export default App;
